class SkillsHelper {
  getSkillsByCategory (skills) {
    let skills_by_category = {}
    for (let i = 0; i < skills.length; i++) {
      let skill = skills[i]
      let category =
        skill.category == undefined ? skill.skill.category : skill.category
      if (skills_by_category[category] == undefined) {
        skills_by_category[category] = []
      }
      skills_by_category[category].push(skill)
    }
    return skills_by_category
  }
}

export default SkillsHelper
